import { render, staticRenderFns } from "./Tipificaciones.vue?vue&type=template&id=634d1f4e&scoped=true&"
import script from "./Tipificaciones.vue?vue&type=script&lang=js&"
export * from "./Tipificaciones.vue?vue&type=script&lang=js&"
import style0 from "./Tipificaciones.vue?vue&type=style&index=0&id=634d1f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d1f4e",
  null
  
)

export default component.exports